import React, { useContext } from 'react';
import { string, arrayOf, shape } from 'prop-types';
import {
  Col,
  Row,
  RadioGroup,
  Radio
} from '@thd-olt-component-react/core-ui';
import { ProductSetContext } from '../../context/ProductSetContext';
import { mapPriceExistsInPackage } from '../../helper';
import './radio-buttons.scss';

export const RadioButtons = ({
  products,
  productGroup
}) => {
  const { toggleActiveProduct } = useContext(ProductSetContext);

  const getPriceDifferenceLabel = (productsArr, product) => {
    const mapExist = mapPriceExistsInPackage(productsArr);
    const label = product.info?.label || '';
    const currentItemValue = product.pricing?.value || 0;

    if (!mapExist && !product.active) {
      const activeItemValue = productsArr.find((activeItem) => activeItem.active).pricing?.value || 0;
      const differenceInPrice = activeItemValue - currentItemValue;
      const priceIndicator = Math.sign(differenceInPrice) >= 0 ? '-' : '+';
      return `${label} (${priceIndicator}$${Math.abs(differenceInPrice).toFixed(2)})`;
    }
    return `${label}`;
  };

  return (
    <Row className="radio-buttons" data-testid="radio-buttons">
      <Col fallback="9" className="radio-buttons__group">
        <RadioGroup>
          {products.map((product, _i, productsArr) => {
            return (
              <Radio
                key={product.itemId}
                id={product.itemId}
                onChange={() => toggleActiveProduct(productGroup, productsArr, product.itemId)}
                value={product.info?.label}
                label={getPriceDifferenceLabel(productsArr, product)}
                checked={product.active}
                padding
              />
            );
          })}
        </RadioGroup>
      </Col>
    </Row>
  );
};

RadioButtons.propTypes = {
  products: arrayOf(shape({})).isRequired,
  productGroup: string.isRequired
};
